import { useEffect, useState } from 'react';

import { useAuthentication } from '@givebacks/api';
import { useGetShortSession } from '@givebacks/api/core';
import { Outlet, useSearchParams } from 'react-router-dom';

import { LoadingScreen } from '../../components/shared/LoadingScreen';

export const ShortSessions = () => {
  const { isAuthenticated, logIn } = useAuthentication();
  const { mutate: getShortSession } = useGetShortSession();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const token = searchParams.get('token');

  useEffect(() => {
    if (!isAuthenticated && token) {
      getShortSession(
        { hash: token },
        {
          onSuccess: (session) => {
            logIn(session);
          },
          onSettled: () => {
            setIsLoading(false);
          },
        }
      );
    } else {
      searchParams.delete('token');
      setSearchParams(searchParams);
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, isAuthenticated]);

  if (isLoading) {
    return <LoadingScreen />;
  }
  return <Outlet context={{}} />;
};
